import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations } from './translations';
type Language = 'en' | 'es';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => any;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// ============================================================
// COMO SE DECIDE EL IDIOMA, EN ORDEN
//   1. ?lang=es / ?lang=en en la URL  -> lo manda el anuncio
//   2. El prefijo de la ruta          -> /offer/ es EN, /oferta/ es ES
//   3. Lo que el visitante eligio antes
//   4. El idioma del navegador
//
// El 1 existe porque mucha gente en USA tiene el telefono en ingles y
// prefiere leer en espanol. El anuncio sabe a quien le habla; el
// navegador no.
// ============================================================
const langFromUrl = (): Language | null => {
  try {
    const raw = (new URLSearchParams(window.location.search).get('lang') || '').toLowerCase();
    if (raw.startsWith('es')) return 'es';
    if (raw.startsWith('en')) return 'en';
  } catch {
    /* noop */
  }
  return null;
};
const langFromPath = (): Language | null => {
  try {
    const p = window.location.pathname;
    if (p.startsWith('/offer/') || p === '/credit') return 'en';
    if (p.startsWith('/oferta/') || p === '/credito') return 'es';
  } catch {
    /* noop */
  }
  return null;
};
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  useEffect(() => {
    const forced = langFromUrl() || langFromPath();
    if (forced) {
      setLanguage(forced);
      return;
    }
    const saved = localStorage.getItem('blinkblis-lang') as Language | null;
    if (saved === 'en' || saved === 'es') {
      setLanguage(saved);
      return;
    }
    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('es')) {
      setLanguage('es');
    }
  }, []);
  useEffect(() => {
    localStorage.setItem('blinkblis-lang', language);
    document.documentElement.lang = language;
  }, [language]);
  const t = (key: string) => {
    const keys = key.split('.');
    let value: any = translations[language];
    for (const k of keys) {
      if (value === undefined) return key;
      value = value[k];
    }
    return value || key;
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-393" data-mp="1d1d8ykfjxdhb">
      {children}
    </LanguageContext.Provider>;
}
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};